import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { EnteteCommande } from '../models';

@Injectable()
export class CommandeService {

  constructor( private apiService: ApiService ) { }

  getAllCommandes(): Observable<[EnteteCommande]>{
  	return this.apiService.get('/commande/historique')
  	  .map( data => data.commandes );
  }

  validateCart(body: any): Observable<EnteteCommande>{
  	return this.apiService.post('/commande/validation', body)
  	  .map( data => data.json().commande );
  }

  payCart(body: any): Observable<any>{
  	return this.apiService.put('/commande/reglement', body)
  	  .map( data => data.commande );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/commandes.service.ts